import { DictionaryItem } from "view360Card/models";
import { DictionaryItemDto } from "view360Card/service/dtos/DictionaryItemDto";
import { DictionaryItemFromDefinedResponse } from "./DictionaryItemFromDefinedResponse";

export class DictionaryItemFromResponse {
    constructor(private dto: DictionaryItemDto | undefined) {}

    domainModel(): DictionaryItem | undefined {
        if (!this.dto) {
            return undefined;
        }

        return new DictionaryItemFromDefinedResponse(this.dto).domainModel();
    }
}